import { CookieConsent } from '@hg/stylizator/components'
import { Optional } from '@hg/stylizator/utils'
import * as React from 'react'
import { useCookies } from 'react-cookie'

import { IFields, initialFields } from 'app/components/CookieConsent/Fields'
import { useGlobalState } from 'app/store'

const CookieConsentCard: React.FC = () => {
  const [blocks] = useGlobalState('reusableBlocks')
  const consentBlock = blocks.get('honeygain-components/cookie-consent')!

  const [cookies, setCookie] = useCookies(['cookieConsent'])
  const cookieConsentFields: Optional<IFields> = cookies.cookieConsent
  const [fields, setFields] = React.useState<IFields>(cookieConsentFields ? cookieConsentFields : initialFields)
  const [visible, setVisible] = React.useState<boolean>(true)

  if (!visible) {
    return null
  }

  return (
    <CookieConsent
      basicData={{
        label: consentBlock.attrs.basicDataLabel,
        state: fields.submitBasicData,
        setState: () => null,
      }}
      usageStats={{
        label: consentBlock.attrs.usageStatsLabel,
        state: fields.submitUsageStats,
        setState: (val) => setFields((prevState) => ({ ...prevState, submitUsageStats: val })),
      }}
      audienceData={{
        label: consentBlock.attrs.audienceDataLabel,
        state: fields.submitAudienceData,
        setState: (val) => setFields((prevState) => ({ ...prevState, submitAudienceData: val })),
      }}
      secondaryButtonText={consentBlock.attrs.secondaryButtonText || 'Accept selected'}
      primaryButtonText={consentBlock.attrs.primaryButtonText || 'Accept all'}
      content={<span dangerouslySetInnerHTML={{ __html: consentBlock.attrs.content }} />}
      heading={consentBlock.attrs.heading}
      illustrationUrl={consentBlock.attrs.illustrationUrl}
      onSecondarySubmit={() => {
        const future = new Date()
        future.setDate(future.getDate() + 30)

        setCookie('cookieConsent', fields, {
          expires: future,
          path: '/',
          domain: `.${location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0]}`,
        })
        setVisible(false)
      }}
      onPrimarySubmit={() => {
        const future = new Date()
        future.setDate(future.getDate() + 30)

        setCookie(
          'cookieConsent',
          {
            submitBasicData: true,
            submitUsageStats: true,
            submitAudienceData: true,
          },
          {
            expires: future,
            path: '/',
            domain: `.${location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0]}`,
          },
        )
        setVisible(false)
      }}
    />
  )
}

export default CookieConsentCard
